export default __webpack_public_path__ + "static/media/Sydney-2022.d3296480.jpg";